import { render, staticRenderFns } from "./fbaOrder.vue?vue&type=template&id=f5a8c02a&"
import script from "./fbaOrder.vue?vue&type=script&lang=js&"
export * from "./fbaOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5a8c02a')) {
      api.createRecord('f5a8c02a', component.options)
    } else {
      api.reload('f5a8c02a', component.options)
    }
    module.hot.accept("./fbaOrder.vue?vue&type=template&id=f5a8c02a&", function () {
      api.rerender('f5a8c02a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/fbaOrder.vue"
export default component.exports